export default __webpack_public_path__ + "static/media/lebensborn_black_500.9b397226.png";